import { z } from "zod";

export const schema = z
  .object({
    fila: z.string().min(1, { message: "Fila é obrigatória" }),
    servico: z.string().min(1, { message: "Serviço é obrigatório" }),
    tempo: z.string().min(1, { message: "Tempo de atendimento é obrigatório" }),
  });
